import React from "react";
import "./App.css";
import Master from "./pages/master";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
// import LanguageProvider from "./components/LanguageProvider";
import {BrowserRouter} from "react-router-dom";

function App() {
  return (
      <BrowserRouter>
      <I18nextProvider i18n={i18n}>{/*handle in each page instead to prefer the API value*/}
        {/*<LanguageProvider /> /!* Global language handling *!/*/}
        <Master />
      </I18nextProvider>
      </BrowserRouter>
  );
}

export default App;
